import * as React from 'react';

import { VerticalScrollable } from '../VerticalScrollable';
import * as styles from './Carousel.css';

interface ICarouselProps {
  sliderRef: React.MutableRefObject<HTMLUListElement | null>;
  action?: React.ReactNode;
}

export const Carousel: React.FC<React.PropsWithChildren<ICarouselProps>> = ({ sliderRef, action, children }) => {
  return (
    <div className={styles['container']}>
      <VerticalScrollable sliderRef={sliderRef} className={styles['scrollable']}>
        {children}
      </VerticalScrollable>
      {action}
    </div>
  );
};
